export default "__VITE_ASSET__Nbam8xj1__"